const allFonts = [
  {
    name: 'Abril Fatface',
    label: 'Abril Fatface',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
  },
  {
    name: 'Aileron Heavy',
    label: 'Aileron Heavy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Aileron Regular',
    label: 'Aileron Regular',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Aileron Thin',
    label: 'Aileron Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Alegreya SC',
    label: 'Alegreya SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Aleo',
    label: 'Aleo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Aleo Light',
    label: 'Aleo Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Alfa Slab One',
    label: 'Alfa Slab One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Alike',
    label: 'Alike',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Allerta Stencil',
    label: 'Allerta Stencil',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Allura',
    label: 'Allura',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Amaranth',
    label: 'Amaranth',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Amatic SC',
    label: 'Amatic SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Anonymous Pro',
    label: 'Anonymous Pro',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Antic',
    label: 'Antic',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Anton',
    label: 'Anton',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Strong',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Architects Daughter',
    label: 'Architects Daughter',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Archivo Black',
    label: 'Archivo Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Archivo Narrow',
    label: 'Archivo Narrow',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Arimo',
    label: 'Arimo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Arvo',
    label: 'Arvo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Bangers',
    label: 'Bangers',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-1.css',
  },
  {
    name: 'Berkshire Swash',
    label: 'Berkshire Swash',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Black Ops One',
    label: 'Black Ops One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Blogger Sans',
    label: 'Blogger Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'BodoniXT',
    label: 'BodoniXT',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cabin Sketch',
    label: 'Cabin Sketch',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cantora One',
    label: 'Cantora One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cardo',
    label: 'Cardo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Carter One',
    label: 'Carter One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Chewy',
    label: 'Chewy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Chunkfive',
    label: 'Chunkfive',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cinzel',
    label: 'Cinzel',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Clicker Script',
    label: 'Clicker Script',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Codystar',
    label: 'Codystar',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Coming Soon',
    label: 'Coming Soon',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cooper Hewitt',
    label: 'Cooper Hewitt',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cooper Hewitt Heavy',
    label: 'Cooper Hewitt Heavy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Cooper Hewitt Thin',
    label: 'Cooper Hewitt Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Courgette',
    label: 'Courgette',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Coustard',
    label: 'Coustard',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Crafty Girls',
    label: 'Crafty Girls',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Creepster',
    label: 'Creepster',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Crushed',
    label: 'Crushed',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Dekko',
    label: 'Dekko',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Diplomata SC',
    label: 'Diplomata SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Dosis',
    label: 'Dosis',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Dr Sugiyama',
    label: 'Dr Sugiyama',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Droid Serif',
    label: 'Droid Serif',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Economica',
    label: 'Economica',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Emilys Candy',
    label: 'Emilys Candy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Engagement',
    label: 'Engagement',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-2.css',
  },
  {
    name: 'Euphoria Script',
    label: 'Euphoria Script',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Exo',
    label: 'Exo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Tech',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Exo Thin',
    label: 'Exo Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Tech',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Faster One',
    label: 'Faster One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Fauna One',
    label: 'Fauna One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Forum',
    label: 'Forum',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Fredoka One',
    label: 'Fredoka One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Germania One',
    label: 'Germania One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Gidole',
    label: 'Gidole',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Glass Antiqua',
    label: 'Glass Antiqua',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Glegoo',
    label: 'Glegoo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Gochi Hand',
    label: 'Gochi Hand',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Graduate',
    label: 'Graduate',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Grand Hotel',
    label: 'Grand Hotel',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Great Vibes',
    label: 'Great Vibes',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Gruppo',
    label: 'Gruppo',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Hammersmith One',
    label: 'Hammersmith One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'IM Fell English',
    label: 'IM Fell English',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'IM Fell English SC',
    label: 'IM Fell English SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Indie Flower',
    label: 'Indie Flower',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Josefin Sans',
    label: 'Josefin Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Josefin Slab',
    label: 'Josefin Slab',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Judson',
    label: 'Judson',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Julius Sans One',
    label: 'Julius Sans One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Kaushan Script',
    label: 'Kaushan Script',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Kite One',
    label: 'Kite One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Knewave',
    label: 'Knewave',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Lato',
    label: 'Lato',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Lato Hairline',
    label: 'Lato Hairline',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'Lato Heavy',
    label: 'Lato Heavy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'League Gothic',
    label: 'League Gothic',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-3.css',
  },
  {
    name: 'League Spartan',
    label: 'League Spartan',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Libre Baskerville',
    label: 'Libre Baskerville',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Lilita One',
    label: 'Lilita One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Limelight',
    label: 'Limelight',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Lobster',
    label: 'Lobster',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Lobster Two',
    label: 'Lobster Two',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Londrina Outline',
    label: 'Londrina Outline',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Londrina Shadow',
    label: 'Londrina Shadow',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Londrina Sketch',
    label: 'Londrina Sketch',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Doodle',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Londrina Solid',
    label: 'Londrina Solid',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Lora',
    label: 'Lora',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Elegant',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Lustria',
    label: 'Lustria',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Megrim',
    label: 'Megrim',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Merriweather',
    label: 'Merriweather',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Merriweather Sans',
    label: 'Merriweather Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Monda',
    label: 'Monda',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Monoton',
    label: 'Monoton',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Montserrat',
    label: 'Montserrat',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Montserrat Extra Bold',
    label: 'Montserrat Extra Bold',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Montserrat Hairline',
    label: 'Montserrat Hairline',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Montserrat Light',
    label: 'Montserrat Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Mr Dafoe',
    label: 'Mr Dafoe',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Niconne',
    label: 'Niconne',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Nixie One',
    label: 'Nixie One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Norwester',
    label: 'Norwester',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Nunito',
    label: 'Nunito',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Nunito Black',
    label: 'Nunito Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Nunito Extra Light',
    label: 'Nunito Extra Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Old Standard TT',
    label: 'Old Standard TT',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Oleo Script',
    label: 'Oleo Script',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-4.css',
  },
  {
    name: 'Open Sans',
    label: 'Open Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Open Sans Extra Bold',
    label: 'Open Sans Extra Bold',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Open Sans Light',
    label: 'Open Sans Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Minimalist',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Oregano',
    label: 'Oregano',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Ostrich Sans',
    label: 'Ostrich Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Ostrich Sans Black',
    label: 'Ostrich Sans Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Ostrich Sans Bold',
    label: 'Ostrich Sans Bold',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Oswald',
    label: 'Oswald',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Oswald Extra Light',
    label: 'Oswald Extra Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Oswald Heavy',
    label: 'Oswald Heavy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Oswald Stencil',
    label: 'Oswald Stencil',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Over The Rainbow',
    label: 'Over The Rainbow',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'PT Mono',
    label: 'PT Mono',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'PT Sans',
    label: 'PT Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'PT Serif',
    label: 'PT Serif',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Pacifico',
    label: 'Pacifico',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Parisienne',
    label: 'Parisienne',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Passion One',
    label: 'Passion One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Patrick Hand',
    label: 'Patrick Hand',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Patrick Hand SC',
    label: 'Patrick Hand SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Patua One',
    label: 'Patua One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Permanent Marker',
    label: 'Permanent Marker',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Pinyon Script',
    label: 'Pinyon Script',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Handwritten',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Pirou',
    label: 'Pirou',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Playfair Display',
    label: 'Playfair Display',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Playfair Display Black',
    label: 'Playfair Display Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Playfair SC',
    label: 'Playfair SC',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-5.css',
  },
  {
    name: 'Playtime With Hot Toddies',
    label: 'Playtime With Hot Toddies',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Cartoon',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Poiret One',
    label: 'Poiret One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Prata',
    label: 'Prata',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Princess Sofia',
    label: 'Princess Sofia',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quando',
    label: 'Quando',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quattrocento Roman',
    label: 'Quattrocento Roman',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quattrocento Sans',
    label: 'Quattrocento Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quicksand',
    label: 'Quicksand',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quicksand Dash',
    label: 'Quicksand Dash',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Quicksand Light',
    label: 'Quicksand Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Racing Sans One',
    label: 'Racing Sans One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Rajdhani',
    label: 'Rajdhani',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Raleway',
    label: 'Raleway',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Raleway Dots',
    label: 'Raleway Dots',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Raleway Extra Bold',
    label: 'Raleway Extra Bold',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Raleway Thin',
    label: 'Raleway Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Ribeye',
    label: 'Ribeye',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Roboto',
    label: 'Roboto',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Roboto Black',
    label: 'Roboto Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Roboto Slab',
    label: 'Roboto Slab',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Roboto Slab Thin',
    label: 'Roboto Slab Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Roboto Thin',
    label: 'Roboto Thin',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Rosario',
    label: 'Rosario',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Rubik One',
    label: 'Rubik One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Rye',
    label: 'Rye',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-6.css',
  },
  {
    name: 'Sacramento',
    label: 'Sacramento',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Sanchez',
    label: 'Sanchez',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Satisfy',
    label: 'Satisfy',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Schoolbell',
    label: 'Schoolbell',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Cartoon',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Shadows Into Light Two',
    label: 'Shadows Into Light Two',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Friendly',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Signika',
    label: 'Signika',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Six Caps',
    label: 'Six Caps',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Sniglet',
    label: 'Sniglet',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Cartoon',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Sans Pro',
    label: 'Source Sans Pro',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Sans Pro Black',
    label: 'Source Sans Pro Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Sans Pro Extra Light',
    label: 'Source Sans Pro Extra Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Serif Pro',
    label: 'Source Serif Pro',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Serif Pro Black',
    label: 'Source Serif Pro Black',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Source Serif Pro Extra Light',
    label: 'Source Serif Pro Extra Light',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Classical',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Special Elite',
    label: 'Special Elite',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Playful',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Stint Ultra Expanded',
    label: 'Stint Ultra Expanded',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Strong',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Sunday',
    label: 'Sunday',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Tenor Sans',
    label: 'Tenor Sans',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Text Me One',
    label: 'Text Me One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Trocchi',
    label: 'Trocchi',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Ubuntu',
    label: 'Ubuntu',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Ultra',
    label: 'Ultra',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Strong',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'UnifrakturMaguntia',
    label: 'UnifrakturMaguntia',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'VT323',
    label: 'VT323',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Vampiro One',
    label: 'Vampiro One',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Vast Shadow',
    label: 'Vast Shadow',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Vidaloka',
    label: 'Vidaloka',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Voga',
    label: 'Voga',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Vollkorn',
    label: 'Vollkorn',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Waterlily',
    label: 'Waterlily',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Yellowtail',
    label: 'Yellowtail',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Apfel Grotezk',
    label: 'Apfel Grotezk',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Bolden',
    label: 'Bolden',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Bold',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Cehua',
    label: 'Cehua',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Modern',
    url: 'https://static.seedeai.com/fonts/latin/fonts-7.css',
  },
  {
    name: 'Crimson',
    label: 'Crimson',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
      {
        value: '700',
        name: 'Bold',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
      {
        value: 'italic',
        name: 'italic',
      },
    ],
    style: 'Elegant',
    url: 'https://static.seedeai.com/fonts/latin/fonts-8.css',
  },
  {
    name: 'Otto Attac',
    label: 'Otto Attac',
    weights: [
      {
        value: '400',
        name: 'Regular',
      },
    ],
    styles: [
      {
        value: 'normal',
        name: 'normal',
      },
    ],
    style: 'Vintage',
    url: 'https://static.seedeai.com/fonts/latin/fonts-8.css',
  },
];

export default allFonts;
